export default "__VITE_ASSET__y5LU7aLx__"